export enum EnvironmentType {
	PORTAL = 'Portal',
	VIEWER = 'Viewer',
	EDGE = 'Edge',
}
